import PagedRequest, { PagedResponse } from "../requests";

export class GetAgentUsersRequest extends PagedRequest {
  agentId: number | null
}

export class GetAgentUsersResponse extends PagedResponse<AgentUserListResource> {
  constructor(AgentUsers: AgentUserListResource[], total: number = 0) {
    super();
    this.items = AgentUsers;
    this.totalItems = total;
  }
}

export class SearchAgentUsersRequest extends PagedRequest {
  name: string;
}

export interface AgentUserListResource {}

export interface AgentUserResource {
  id: number;
  externalId: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  roleId: number;
  roleName: string;
  agentId: number;
  agentName: string;
  facilityString: string;
  isActive: boolean;
  lastAccess: Date | null;
  password: string | null;
  confirmPassword: string | null;
  hasAccessToAllFacilities: boolean;
  hasAccessToAllAgentFacilities: boolean;
  isSuperUser: boolean;
  isUserManager: boolean;
}

export interface AgentUserRoleResource {
  id: number;
  name: string;
}

export class SaveAgentUserRequest {
  id?: number = null;
  externalId: string;
  firstName: string;
  lastName: string;
  email: string;
  agentId: number;
  roleId: number;
  phone: string;
  hasAccessToAllAgentFacilities: boolean;
  hasAccessToAllFacilities: boolean;
  facilities: string[] | null
  isActive: boolean;
  password: string | null;
  confirmPassword: string | null;
  isSuperUser: boolean | null;
  isUserManager: boolean | null;
  get isNew() {
    return this.id === null;
  }
}

export interface SaveAgentUserResponse {
  externalId: number;
  errorMessage: any;
}
